import { render, staticRenderFns } from "./load-more.vue?vue&type=template&id=5d6037b8"
import script from "./load-more.vue?vue&type=script&lang=js"
export * from "./load-more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports